import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class BankAccountExportConfiguration {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  accountNumber!: string;
  @IsString()
  @Expose()
  fullAccountNumber!: string;
  @IsString()
  @Expose()
  description!: string;
}
